// extracted by mini-css-extract-plugin
module.exports = {"icon":"yyn2asaN1WQ9n61fY0Snl"};